export const getOrderButtonText = ({
  isLoading,
  activeOrder,
  orderButtonText,
  getString,
}: {
  isLoading: boolean;
  activeOrder: boolean;
  orderButtonText: string;
  getString: (value: string) => string;
}) => {
  if (isLoading) return getString("ordering.validating");
  if (activeOrder) return getString("ordering.processing");
  return orderButtonText;
};
